import React from 'react'
import {
  BrowserRouter,
  Route,
} from 'react-router-dom'
import {
  lightBlue900,
  lightBlue700,
  amber600,
  teal900,
  teal700,
  orange700,
  orange500,
  indigo800,
  redA700,
  black,
  grey500,
} from 'material-ui/styles/colors';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import constants from "./common/constants";
import Keypad1280x800 from './keypad/Keypad-1280x800.js';
import Keypad1280x728 from './keypad/Keypad-1280x728.js';
import KeypadWithBooking from './keypad/KeypadWithBooking.js';
import Keypad from './keypad/Keypad.js';
import KeypadLogin from './keypad/KeypadLogin.js';
import Display from './display/Display.js';
import Ticket from './ticket/Ticket.js';
import Home from './home/Home.js';
import AdminPanel from './adminPanel/AdminPanel.js';
import * as commonHistory from './common/history.js';

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: black,
    primary2Color: grey500,
    // primary3Color: amber500,
    accent1Color: grey500,
    // accent2Color: amber500,
    // accent3Color: amber500,
    pickerHeaderColor: black,
  },
});


function InitHistory({ history }) {
  if (!commonHistory.isInited()) commonHistory.init(history);

  return null;
}

const Router = () => (
  <MuiThemeProvider muiTheme={muiTheme}>
    <BrowserRouter>
      <div>
        <Route path="/"
               render={(props) => <InitHistory {...props} />}
        />
        <Route path="/home" component={Home} />
        <Route path="/keypad"
               component={KeypadWithBooking} />
        <Route path="/display" component={Display} />
        <Route path="/ticket" component={Ticket} />
        <Route path="/adminPanel" component={AdminPanel} />
        <Route path="/keypad-login"
               component={KeypadLogin} />
      </div>
    </BrowserRouter>
  </MuiThemeProvider>
);

export default Router


// WEBPACK FOOTER //
// client/router.js